// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d87a3a1624dd2b39a6000a9a20896604010c72a3/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};